// extracted by mini-css-extract-plugin
module.exports = {"badges":"Mobile_badges__eODAp"};